import React from 'react'
import './footer.scss'

const Footer = () => {
  return (
    <div className='footer'>
      <span>FiddiAdmin</span>
      <span>&copy; Fardeen Admin Dashboard</span>
    </div>
  )
}

export default Footer;